import {
  TimeEntry,
  UpsertBreakDto,
  TimeManagementFilters,
  TimeManagementListItem,
  CreateTimeManagementDto,
  UpdateTimeManagementDto,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";
import { Paginated } from "../../../shared/types/IPaginationResponse";

export const timeEntryApi = {
  upsertBreak: (dto: UpsertBreakDto) =>
    apiClient.put<TimeEntry>("/time-entries/break", dto),

  deleteBreak: (id: number) =>
    apiClient.delete(`/time-entries/break/${id}`),

  searchTimeManagement: (params: TimeManagementFilters & { page: number }) =>
    apiClient.get<Paginated<TimeManagementListItem>>("/time-entries/time-management", { params }),

  createTimeManagement: (dto: CreateTimeManagementDto) =>
    apiClient.post<TimeEntry>("/time-entries/time-management", dto),

  deleteTimeManagement: (id: number) =>
    apiClient.delete(`/time-entries/time-management/${id}`),

  getTimeManagementById: (id: number) =>
    apiClient.get<TimeManagementListItem>(`/time-entries/time-management/${id}`),

  updateTimeManagement: (id: number, dto: UpdateTimeManagementDto) =>
    apiClient.patch<TimeEntry>(`/time-entries/time-management/${id}`, dto),
};
